<!-- <template>
    <div v-if="isVisible" class="_alert rounded" :class="status == 'success'
            ? 'bg-success text-white'
            : status == 'error'
                ? 'bg-danger text-white'
                : status == 'warning'
                    ? 'bg-warning text-white'
                    : status == 'info'
                        ? 'bg-info text-white'
                        : status == 'primary'
                            ? 'bg-primary text-white'
                            : ''
        ">
        <div class="p-1 row align-items-center">
            <div v-if="status" class="col-auto">
                <i v-if="status == 'success'" class="bi bi-check2-all text-white fs-5"></i>
                <i v-if="status == 'error'" class="bi bi-x-circle text-white fs-5"></i>
                <i v-if="status == 'warning'" class="bi bi-exclamation-triangle text-white fs-5"></i>
                <i v-if="status == 'info'" class="bi bi-info-circle text-white fs-5"></i>
                <i v-if="status == 'primary'" class="bi bi-star text-white fs-5"></i>
            </div>
            <div class="col p-0" v-html="message"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false,
            message: "",
            status: "",
        };
    },
    methods: {
        showToast(message, status) {
            this.message = message;
            this.status = status;
            this.isVisible = true;

            setTimeout(() => {
                this.isVisible = false;
                this.message = "";
                this.status = "";
            }, 3000); // Automatically hide after 3 seconds
        },
    },
};
</script>

<style scoped>
._alert {
    width: auto !important;
    min-width: 300px !important;
    right: 10px;
    padding-right: 30px;
    top: 80px;
    height: 45px;
    display: flex;
    align-items: center;
    text-align: start;
    position: absolute;
    z-index: 10000 !important;
}
</style> -->
<template>
    <div v-if="isVisible" class="_alert border rounded shadow" :class="status == 'success'
        ? 'bg-white text-success'
        : status == 'error'
        ? 'bg-white text-danger border border-danger'
            : status == 'warning'
            ? 'bg-white text-warning border border-warning'
                : status == 'info'
                ? 'bg-white text-info border border-info'
                    : status == 'primary'
                    ? 'bg-white text-primary border border-primary'
                        : ''
        ">
        <div class="p-3 align-items-center">
            <div v-if="status" class="col-auto text-center">
                <i v-if="status == 'success'" class="bi bi-check2-all text-success fs-6"></i>
                <i v-if="status == 'error'" class="bi bi-x-circle text-danger fs-6"></i>
                <i v-if="status == 'warning'" class="bi bi-exclamation-triangle text-warning fs-6"></i>
                <i v-if="status == 'info'" class="bi bi-info-circle text-info fs-6"></i>
                <i v-if="status == 'primary'" class="bi bi-star text-primary fs-6"></i>
            </div>
            <br>
            <div class="col text-center p-0 fs-5" v-html="message"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false,
            message: "",
            status: "",
        };
    },
    methods: {
        showToast(message, status) {
            this.message = message;
            this.status = status;
            this.isVisible = true;

            setTimeout(() => {
                this.isVisible = false;
                this.message = "";
                this.status = "";
            }, 3000); // Automatically hide after 3 seconds
        },
    },
};
</script>

<style scoped>
._alert {
    width: auto !important;
    min-width: 400px !important;
    right: 50%;
    top: 50%;
    transform: translate(50%, -50%);
    padding: 20px;
    height: auto;
    max-width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: start;
    position: absolute;
    z-index: 9999 !important; /* Ensure it's on top */
    border-radius: 8px;  /* Card-like rounded corners */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);  /* Shadow for card effect */
}

._alert .row {
    width: 100%;
    /* Ensure row takes full width of the parent */
    display: flex;
    align-items: center;
}

._alert .col-auto {
    margin-right: 10px;  /* Space between icon and message */
}

._alert .col {
    flex-grow: 1;
    /* Allow message to take remaining space */
    word-wrap: break-word;  /* Handle long messages */
}

.bi {
    font-size: 3.5rem !important;  /* Icon size */
}
</style>
